import { render } from "./NewAddressPage.vue?vue&type=template&id=5f827b95&scoped=true&ts=true"
import script from "./NewAddressPage.vue?vue&type=script&lang=ts"
export * from "./NewAddressPage.vue?vue&type=script&lang=ts"

import "./NewAddressPage.vue?vue&type=style&index=0&id=5f827b95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f827b95"]])

export default __exports__